import { Hospital } from '../utils/dataTypes';
import { pimsApi } from './pimsApi';

// Define a service using a base URL and expected endpoints
export const hospitalApi = pimsApi.injectEndpoints({
	endpoints: (builder) => ({
		getHospitalById: builder.query<Hospital, number>({
			query: (hospital_id) => `hospital/${hospital_id}`,
			providesTags: (result, error, id) => [{ type: 'Hospital', id }],
			transformResponse: (response: { data: Hospital }) => response.data,
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints

export const { useGetHospitalByIdQuery } = hospitalApi;
